import { useBoardIdFromBoardOrCardRoute } from 'app/src/components/Board/useBoardIdFromBoardOrCardRoute';
import { useSandboxEnterpriseQuery } from './SandboxEnterpriseQuery.generated';

export const useBoardEnterpriseId = ({ skip = false }: { skip?: boolean }) => {
  const idBoard = useBoardIdFromBoardOrCardRoute() || '';

  const { data } = useSandboxEnterpriseQuery({
    variables: { idBoard },
    waitOn: ['CurrentBoardInfo', 'CurrentBoardListsCards'],
    fetchPolicy: 'cache-only',
    skip,
  });

  const boardEnterpriseId = data?.board?.enterprise?.id ?? '';
  return boardEnterpriseId;
};
